<template>
  <v-dialog v-model="dialogDeletePositionInGroup" persistent max-width="400">
    <v-card height="180px" style="border-radius: 12px;">
      <v-card-title class="button-color-outline ra-head-text-bold justify-center pa-5" style="font-size: 18px">ต้องการลบข้อมูลนี้ใช่หรือไม่</v-card-title>
      <v-card-text class="justify-center text-center">
      <span class="ra-head-text justify-center" style="font-size: 16px">หากยืนยัน จะทำการลบระดับตำแหน่งออกจากกลุ่ม</span>
      <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="button-color-outline pl-5 pr-5 mr-3" style="border-radius: 6px;" outlined @click="closeDialog">ยกเลิก</v-btn>
        <v-btn class="button-color pl-5 pr-5" style="border-radius: 6px;" dark @click="deletePositionData()">ยืนยัน</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { deletePositionLevelInGroup } from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'

export default {
  data () {
    return {
      dialogDeletePositionInGroup: false,
      deleteId: '',
      deleteGroupId: ''
    }
  },
  mounted () {
    EventBus.$on('opendialogDeletePositionInGroup', this.openDialogDeletePositionInGroup)
  },
  beforeDestroy () {
    EventBus.$off('opendialogDeletePositionInGroup')
  },
  methods: {
    openDialogDeletePositionInGroup (value) {
      this.deleteId = value.positionId
      this.deleteGroupId = value.positionGroupId
      this.dialogDeletePositionInGroup = true
    },
    closeDialog () {
      this.deleteId = ''
      this.deleteGroupId = ''
      this.dialogDeletePositionInGroup = false
    },
    async deletePositionData () {
      const data = {
        id: this.deleteGroupId,
        positionId: this.deleteId
      }
      const token = this.$store.state.token
      try {
        const res = await deletePositionLevelInGroup(data, token)
        if (res.success) {
          swal('สำเร็จ', 'ลบระดับตำแหน่งภายในกลุ่มเรียบร้อย', 'success', {
            button: false,
            timer: 2000
          })
          EventBus.$emit('confirmedDelete')
          this.closeDialog()
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped></style>
